import React from "react";
import "react-phone-number-input/style.css";

import AppRouting from "./routing/AppRouting";
import InactivityHandler from "./components/InactivityHandler";
import InternetConnectionChecker from "./components/InternetConnectionChecker";

import { Provider as ChakraProvider } from "./components/ui/provider";
import { HttpQueryProvider } from "./contexts/HttpQueryContext";
import { UserProvider } from "./contexts/UserContext";
import { SocketProvider } from "./contexts/SocketContext";
import { NotificationsProvider } from "./contexts/NotificationsContext";

import { HelmetProvider } from "@dr.pogodin/react-helmet";

function App() {
  return (
    <HttpQueryProvider>
      <UserProvider>
        <SocketProvider>
          <NotificationsProvider>
            <ChakraProvider>
              <HelmetProvider>
                <InactivityHandler />
                <InternetConnectionChecker />
                <AppRouting />
              </HelmetProvider>
            </ChakraProvider>
          </NotificationsProvider>
        </SocketProvider>
      </UserProvider>
    </HttpQueryProvider>
  );
}

export default App;
